import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=b4b2fc26&scoped=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=b4b2fc26&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b2fc26",
  null
  
)

export default component.exports